<app-loading-overlay [isLoading]="isSavingDraft || isSubmittingQuery"></app-loading-overlay>
<section class="standard-templates-wrapper">
  <div class="content-panel">
    <div class="panel-header">
      <div class="header-title">
        <nz-form-label class="nfl-form-label" nzNoColon>{{ isCodeView ? 'Code' : 'Query Details' }}</nz-form-label>
        <button
          *ngIf="isCodeView && !isMarketingUser"
          [disabled]="standardTemplateForm.invalid"
          nz-tooltip
          [nzTooltipTitle]="
            standardTemplateForm.invalid ? 'Please fill in all required fields before editing the code.' : ''
          "
          class="code-title-icon"
          (click)="onEditCodeClick()"
        >
          <span nz-icon nzType="edit"></span>
        </button>
      </div>
      <button
        nz-button
        nzType="default"
        class="view-code-button disabled-btn"
        [disabled]="isViewCodeDisabled"
        (click)="toggleCodeQueryView()"
      >
        <span nz-icon [nzType]="isCodeView ? 'swap' : 'code'" nzTheme="outline"></span>
        {{ isCodeView ? 'View Query' : 'View Code' }}
      </button>
    </div>

    <form
      class="panel-body"
      nz-form
      [formGroup]="standardTemplateForm"
      [style.display]="isCodeView ? 'none' : null"
      nzLayout="vertical"
    >
      <div nz-row [nzGutter]="[16, 16]">
        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12" [nzLg]="12" [nzXl]="12">
          <nz-form-item>
            <nz-form-label nzFor="standard-template-select" class="nfl-form-label" nzRequired nzNoColon
              >Select Template</nz-form-label
            >
            <nz-form-control nzErrorTip="Template is required">
              <nz-select
                id="standard-template-select"
                class="w100"
                nzSize="default"
                nzPlaceHolder="Select Pre-templated Queries"
                formControlName="templateId"
              >
                <nz-option
                  *ngFor="let option of templateOptions"
                  [nzLabel]="option.label"
                  [nzValue]="option.value"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="12" [nzLg]="12" [nzXl]="12">
          <nz-form-item>
            <nz-form-label nzFor="alias-input" class="nfl-form-label" nzRequired nzNoColon>Alias</nz-form-label>
            <nz-form-control [nzErrorTip]="nameErrorTemplate">
              <input
                id="alias-input"
                nz-input
                nzSize="default"
                placeholder="Add Alias"
                formControlName="alias"
                maxlength="45"
              />
            </nz-form-control>
            <ng-template #nameErrorTemplate let-control>
              <div *ngIf="control?.errors?.['required']">Alias is required when selecting a template.</div>
              <div *ngIf="control?.errors?.['maxlength']">
                Alias cannot exceed
                {{ control?.errors?.['maxlength'].requiredLength }} characters.
              </div>
              <div *ngIf="control?.errors?.['pattern']">
                Alias should not contain any special characters and should have at least one alphabet.
              </div>
            </ng-template>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="24">
          <div class="info-section">
            <nz-form-label class="nfl-form-label section-heading" nzNoColon>
              <span nz-icon nzType="info-circle" nzTheme="outline"></span>
              Details
            </nz-form-label>
            <p class="description">{{ selectedTemplateDescription }}</p>
          </div>
        </div>

        <div nz-col [nzSpan]="24">
          <div class="filter-section">
            <nz-form-label class="nfl-form-label section-heading" nzNoColon>
              <span nz-icon nzType="filter" nzTheme="outline"></span>
              Filters
            </nz-form-label>

            <div nz-row [nzGutter]="[16, 16]" [formGroup]="filtersFormGroup">
              <div
                nz-col
                [nzXs]="24"
                [nzSm]="24"
                [nzMd]="12"
                [nzLg]="12"
                [nzXl]="12"
                class="filter-control"
                *ngFor="let filterGroup of filterGroups; let idx = index"
              >
                <nz-form-item>
                  <nz-form-label [nzFor]="'filter-select-' + idx" class="nfl-form-label" nzRequired nzNoColon>
                    {{ filterGroup.displayName | titlecase }}
                  </nz-form-label>
                  <nz-form-control [nzErrorTip]="filterRequiredTemplate">
                    <nz-select
                      [id]="'filter-select-' + idx"
                      class="w100"
                      nzSize="default"
                      nzMode="multiple"
                      (ngModelChange)="onFilterSelectionChange(filterGroup.name, $event)"
                      [formControlName]="filterGroup.name"
                    >
                      <nz-option
                        *ngFor="let option of filterGroup.options"
                        [nzLabel]="option.label"
                        [nzValue]="option.value"
                      ></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #filterRequiredTemplate let-control>
                    <div *ngIf="control?.errors?.['required']">
                      {{ filterGroup.displayName | titlecase }} is required.
                    </div>
                  </ng-template>
                </nz-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="panel-body code-preview-panel" [style.display]="isCodeView ? null : 'none'">
      <div class="code-preview-box">
        <pre>{{ generatedQuery }}</pre>
      </div>
    </div>
  </div>

  <div class="footer-action" *ngIf="!isCodeView">
    <!--hide draft button for now -->
    <button
      *ngIf="false"
      nz-button
      nzType="default"
      nzSize="large"
      class="generate-button disabled-btn"
      [disabled]="standardTemplateForm.invalid || isSavingDraft || isSubmittingQuery"
      [nzLoading]="isSavingDraft"
      (click)="onSaveAsDraftClick()"
    >
      Save as Drafts
    </button>
    <button
      nz-button
      nzType="default"
      nzSize="large"
      nzSuccess
      class="generate-button disabled-btn"
      [disabled]="standardTemplateForm.invalid || isSavingDraft || isSubmittingQuery"
      [nzLoading]="isSubmittingQuery"
      (click)="onGenerateDataClick()"
    >
      Generate Data
    </button>
  </div>

  <nz-modal
    [(nzVisible)]="isEditQueryModalVisible"
    [nzClosable]="false"
    [nzMaskClosable]="false"
    [nzKeyboard]="false"
    [nzFooter]="modalFooter"
    nzCentered
    nzWrapClassName="edit-query-modal-wrap"
  >
    <ng-container *nzModalContent>
      <div class="edit-modal-content">
        <div class="edit-modal-icon-wrap">
          <span nz-icon nzType="warning" nzTheme="outline" class="edit-modal-icon"></span>
        </div>
        <h3 class="edit-modal-title">Do you want to edit query?</h3>
        <p class="edit-modal-description">
          You are about to switch to a custom query. Please note that while the current query text will be retained, any
          selected templates or in-progress configurations will not be saved.
        </p>
      </div>
    </ng-container>

    <ng-template #modalFooter>
      <div class="edit-modal-footer">
        <button nz-button nzType="default" class="keep-query-btn disabled-btn" (click)="closeEditQueryModal()">
          No, keep the existing query
        </button>
        <button nz-button nzType="primary" class="edit-query-btn disabled-btn" (click)="confirmEditQuery()">
          Yes, edit query
        </button>
      </div>
    </ng-template>
  </nz-modal>
</section>
